import Base from '../Pages/Base'
import ListCategoriasLegis from '../Pages/Categorias/List'
import FormCategoriasLegis from '../Pages/Categorias/Form'
import ListLegislacao from '../Pages/Legislacao/List'
import FormLegislacao from '../Pages/Legislacao/Form'

export default [
	{
		path: 'servicos/legislacao',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasLegis',
				component: ListCategoriasLegis,
				meta: {
					path: '/servicos/legislacao',
					pai: 'Serviços',
					title: 'Admin - Legislação',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislação',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasLegis',
				component: FormCategoriasLegis,
				meta: {
					path: '/servicos/legislacao',
					pai: 'Serviços',
					title: 'Admin - Legislação - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislação',
						class: '',
						active: false,
						url: '/servicos/legislacao'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasLegisEditar',
				component: FormCategoriasLegis,
				meta: {
					path: '/servicos/legislacao',
					pai: 'Serviços',
					title: 'Admin - Legislação - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislação',
						class: '',
						active: false,
						url: '/servicos/legislacao'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListLegislacao',
				component: ListLegislacao,
				meta: {
					path: '/servicos/legislacao',
					pai: 'Serviços',
					title: 'Admin - Legislação - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislação',
						class: '',
						active: false,
						url: '/servicos/legislacao'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormLegislacao',
				component: FormLegislacao,
				meta: {
					path: '/servicos/legislacao',
					pai: 'Serviços',
					title: 'Admin - Legislação - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislação',
						class: '',
						active: false,
						url: '/servicos/legislacao'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormLegislacaoEditar',
				component: FormLegislacao,
				meta: {
					path: '/servicos/legislacao',
					pai: 'Serviços',
					title: 'Admin - Legislação - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Legislação',
						class: '',
						active: false,
						url: '/servicos/legislacao'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]